import "./index.scss";
import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
import OnDemand from "../../../assets/img/Featured/app-ondemand.png";
import Reserve from "../../../assets/img/Featured/app-reservations.png";

const ResidencesPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return (
      <div className="page residencesPage">
        <Header />
        <div className="page-header">Residential Building</div>
        <div className="text-wrapper">
          <div className="top">
            <div className="topic-header">Residences</div>
            <HorizontalLine />
          </div>
          <div className="std-text">
            Delight residents and their families with food and beverage
            at-a-click advanced ordering for pick-up at any venue in the
            community.{'\n\n'}

            Fast, easy, mobile ordering and payment drives order
            volume and grows F&B revenue.{'\n\n'}

            Allow residents to choose their
            preferred table when making dining reservations.{'\n\n'}

            Use Graphical KPI dashboards and reports to 
            analyze performance and identify opportunities to 
            improve service and operations.
          </div>
        </div>

        <FeaturedSolutions>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Residences", "IG OnDemand");
              addFlow("IG OnDemand");
              navigate("/solutions/ig-on-demand");
            }}
          >
            <img src={OnDemand} alt="" />
            <div className="item-head">
              <LogoMini />
              IG OnDemand
            </div>
          </div>
          <div
            className="featured-item"
            onClick={() => {
              _logEvent("click", "Residential Building - Residences", "Reserve");
              addFlow("Reserve");
              navigate("/solutions/reserve");
            }}
          >
            <img src={Reserve} alt="" />
            <div className="item-head">
              <LogoMini />
              Reserve
            </div>
          </div>
        </FeaturedSolutions>
      </div>
    );
}
export default ResidencesPage;